import { MENU_ITEMS } from '../constants/menuItems';

/**
 * Utility function to filter menu items based on the user's role.
 * It returns only the items that do not require a specific role or match the given user role.
 *
 * @param {string} userRole - The role of the current user.
 * @returns {Array} Filtered menu items accessible to the user.
 */
export const getFilteredMenuItems = (userRole) => {
  return MENU_ITEMS.filter((item) => !item.requiredRole || item.requiredRole === userRole);
};
